<template>
  <page-outline :title="$t('Webheader.payment_schedule_list')">
    <template slot="pageContent">
      <b-container fluid>
        <div class="requestsList">
          <div class="mt-0">
            <div>
              <b-row class="text-xl-start mb-3">
                <b-col xl="6" lg="9" md="12" cols="12">
                  <b-button-group class="mt-3 mt-sm-0">
                    <b-button class="px-4" :variant="tabName === 1 ? 'primary btn-selected' : ''" @click="changeTabName(1)">{{ $t('mandate.unit') }}</b-button>
                    <b-button class="px-4" :variant="tabName === 2 ? 'primary btn-selected' : ''" @click="changeTabName(2)">{{ $t('mandate.bulk') }}</b-button>
                  </b-button-group>
                </b-col>
              </b-row>

              <Unit v-if="tabName === 1"></Unit>
              <Bulk v-else-if="tabName === 2"></Bulk>
            </div>
          </div>
        </div>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import conf from '../../config/config.dev.js'
import PageOutline from '@/components/common/PageOutline.vue'
import BackButton from '@/components/common/backButton.vue'
import Unit from './PaymentScheduleListUnit.vue'
import Bulk from './PaymentScheduleListBulk.vue'


export default {
  name: 'PaymentScheduleListGroup',
  components: {
    Unit,
    Bulk,
    BackButton,
    'page-outline': PageOutline,
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    additionalClass: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      activateSpinner: false,
      BIC: '',
      dateBegin: '',
      dateEnd: '',
      displayFilter: false,
      filterBy: '',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      hasDefaultFilter: false,
      IBAN: '',
      identifier: '',
      idTrackAcc: '',
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      returnUrl: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      statusVerification: '',
      tabName: 1,
      technicalStatus: '',
      trackActive: '',
      TracksList: [],
      TrackType: ''
    }
  },
  created () {
    if (this.type === 'unit') {
      this.tabName = 1
    } else if (this.type === 'bulk') {
      this.tabName = 2
    } else {
      this.tabName = 1
    }
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  methods: {
    changeTabName (tabName) {
      this.tabName = tabName
    }
  }
}
</script>
<style scoped>
.btn.btn-secondary {
  background: var(--actionButtonColorViolet);
  border: 2px solid var(--borderButtonColorBlue);
  color: var(--actionTextColorBlue);
}
</style>
